import { useQuery } from "@tanstack/react-query";

import { getProvinces } from "../api/queries";

export const useProvincesQuery = () => useQuery({
  queryKey: ["provinces"],
  queryFn: getProvinces,
});
